import { createContext, ReactNode, useContext, useState } from 'react';
import { AnalyticsConfig, defaultOverviewConfig } from '../types/overview';

interface OverviewConfigContextProps {
  config: AnalyticsConfig;
  setConfig: (config: AnalyticsConfig) => void;
}

export const OverviewConfigContext = createContext<OverviewConfigContextProps>({
  config: defaultOverviewConfig,
  setConfig: () => {},
});

export function OverviewConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<AnalyticsConfig>(defaultOverviewConfig);

  return (
    <OverviewConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </OverviewConfigContext.Provider>
  );
}

export function useOverviewConfig() {
  return useContext(OverviewConfigContext);
}
